<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/sppd">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading" class="margin-bottom">
            <div slot="title">
              <h4 class="margin-remove">{{ "PP Manifest".toUpperCase() }}</h4>
              <small>{{ data.manifest.no_pp }}</small>
            </div>
            <a-popover slot="extra" trigger="click" placement="bottom">
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li>
                  <a-button
                    type="primary"
                    icon="printer"
                    block
                    ghost
                    :loading="printLoad.manifest"
                    @click="handlePrintManifest"
                    >Manifest</a-button
                  >
                </li>
                <li v-if="getAuth.username == data.manifest.tlc_pembuat">
                  <a-button-group>
                    <a-button
                      :disabled="
                        !(
                          data.manifest.status !== 'Canceled' &&
                          data.manifest.status !== 'Rejected' &&
                          data.manifest.status !== 'Closed' &&
                          getAuth.username == data.manifest.tlc_pembuat &&
                          !(data.ispibkkuploaded && data.ispibkkuploaded == '1')
                        )
                      "
                      type="dashed"
                      icon="edit"
                      @click="handleEdit"
                      >Edit</a-button
                    >
                    <a-button
                      @click="handlecanceltrans"
                      :disabled="
                        data.canceled_status !== '0' &&
                        getAuth.username == data.manifest.tlc_pembuat
                      "
                      type="danger"
                      icon="close-square"
                      :loading="printLoad.cancel"
                      >Cancel</a-button
                    >
                    <a-button
                      @click="handleclosetrans"
                      :disabled="
                        (data.closed_status == '1' &&
                          getAuth.username == data.manifest.tlc_pembuat) ||
                        (data.closed_status == '1' &&
                          data.canceled_status == '1')
                      "
                      type="danger"
                      icon="close-square"
                      :loading="printLoad.close"
                      >Close</a-button
                    >
                  </a-button-group>
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{
                    moment(data.manifest.tanggal).format(getDefaultDateFormat)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.manifest.user_pembuat
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Cost Center / Peruntukan</span>
                  <span class="m-list-desc">{{
                    data.manifest.kode_project +
                    " / " +
                    data.manifest.allocation
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Description</span>
                  <span class="m-list-desc">{{ data.manifest.deskripsi }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Be Required</span>
                  <span class="m-list-desc">{{
                    moment(data.manifest.be_required).format(
                      getDefaultDateFormat
                    )
                  }}</span>
                </li>
                <li hidden>
                  <span class="m-list-title" for>Lead Time</span>
                  <span class="m-list-desc">{{ data.manifest.lead_time }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>End User</span>
                  <span class="m-list-desc">{{ data.manifest.end_user }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Category</span>
                  <span class="m-list-desc">{{
                    data.manifest.used_for == "1"
                      ? "Goods and Service Procurement"
                      : data.manifest.used_for == "2"
                      ? "F&B and Household Supplies"
                      : data.manifest.used_for == "3"
                      ? "Payment instruction"
                      : data.manifest.used_for == "4"
                      ? "Commision"
                      : data.manifest.used_for == "5"
                      ? "Other"
                      : data.manifest.used_for
                  }}</span>
                </li>
                <!-- <li>
                  <span class="m-list-title" for>type activity</span>
                  <span class="m-list-desc">{{ data.manifest.type_activity }}</span>
                </li>
                <li v-if="data.manifest.activity">
                  <span class="m-list-title" for>activity</span>
                  <span class="m-list-desc">{{ data.manifest.activity }}</span>
                </li>
                <li v-if="data.manifest.pipeline_no && data.manifest.pipeline_no!='-'">
                  <span class="m-list-title" for>Pipeline No.</span>
                  <span class="m-list-desc">{{ data.manifest.pipeline_no && data.manifest.pipeline_no!='-' ? data.manifest.pipeline_no+" | "+  data.manifest.definitions : "-" }}</span>
                </li> -->
                <li v-if="data.manifest.prospek_description">
                  <span class="m-list-title" for>Prospect</span>
                  <span class="m-list-desc">{{ data.manifest.prospek_description }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-card :loading="loading" class="margin-bottom">
            <div slot="title">Financial Detail</div>
            <div>
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Currency</span>
                  <span class="m-list-desc">{{ data.keuangan.mata_uang }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Price Estimation</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.keuangan.estimasi_harga)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Exchange Rate</span>
                  <span class="m-list-desc">{{
                    formatCurrencyCode(
                      data.keuangan.currency_project,
                      data.keuangan.kurs
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>CONVERSION VALUE</span>
                  <span class="m-list-desc">{{
                    formatCurrencyCode(
                      data.keuangan.currency_project,
                      data.keuangan.hasil_konversi
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Downpayment</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.keuangan.downpayment)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total Usage</span>
                  <span class="m-list-desc">{{
                    formatCurrency(
                      data.mata_uang,
                      data.total_pemakaian ? data.total_pemakaian : 0
                    )
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Balance</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.mata_uang, data.keuangan.saldo)
                  }}</span>
                </li>
              </ul>
            </div>
          </a-card>
          <a-card v-if="getScreen">
            <div slot="title">Usage Details</div>
            <a-list
              itemLayout="vertical"
              :dataSource="initialList.output"
              :pagination="pagination"
            >
              <Empty
                v-if="
                  initialList.output
                    ? initialList.output.length <= 0
                    : initialList.output
                "
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div slot="title">
                    <span>{{ item.data.nama_barang }}</span
                    ><br />
                    <a class="m-display-block" @click="handletomanifestAngg(item.data.anggaran_id, item.data.tahun_anggaran, item.data.path)">{{ item.data.kode_anggaran }}</a>
                    <span>{{ item.data.nama_anggaran }}</span>
                  </div>
                  <div slot="description" class="margin-remove">
                    <div class="m-display-flex space-between">
                      <span
                        >{{ item.data.jumlah_barang }}&nbsp;{{
                          item.data.satuan
                        }}</span
                      >
                      <div>
                        <h4 class="margin-remove m-text-align right">
                          @
                          {{ formatCurrency(data.mata_uang, item.data.harga) }}
                        </h4>
                        <h4 v-if="Number(item.data.bailout_value)>0" class="margin-remove m-text-align right">
                          Bailout :
                          {{ formatCurrency(data.mata_uang, Number(item.data.bailout_value)) }}
                        </h4>
                      </div>
                    </div>
                    <h3 class="margin-remove m-text-align right">
                      Sub Total :
                      {{ formatCurrency(data.mata_uang, item.totalHarga) }}
                    </h3>
                  </div>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
            <div class="m-price-total">
              <div v-if="totalBailout>0">
                <span class="m-list-title">
                  Total Bailout :
                  {{
                  formatRupiah(totalBailout, "IDR" )
                  }}
                </span>
                <a-divider class="margin-small" />
              </div>
              <a-statistic
                title="Grand Total"
                :value="formatCurrency(data.mata_uang, initialList.grandTotal)"
                class="m-text-align right"
              />
            </div>
          </a-card>
          <a-collapse v-if="!getScreen" class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <h4 slot="header" class="margin-remove">Usage Details</h4>
              <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                :change="searching"
                class="margin-bottom"
              />
              <a-table
                :columns="columns"
                :dataSource="tableData"
                :pagination="pagination"
                size="small"
                bordered
                :scroll="{ x: 100 }"
              >
                <div slot="item_name" slot-scope="item_name">
                  <h4 class="margin-remove">{{ item_name.item_name }}</h4>
                  <a class="m-display-block" @click="handletomanifestAngg(item_name.anggaran_id, item_name.tahun_anggaran, item_name.path)">{{ item_name.kode_anggaran }}</a>
                  <span>{{item_name.nama_anggaran}}</span>
                </div>
                <span slot="unit_price" slot-scope="unit_price">
                  <CurrencyJustified
                    v-if="unit_price.val"
                    :currencyValue="unit_price.curr"
                    :valueNumber="unit_price.val"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="amount" slot-scope="amount">
                  <CurrencyJustified
                    v-if="amount.val"
                    :currencyValue="amount.curr"
                    :valueNumber="amount.val"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="bailout" slot-scope="item">
                  <CurrencyJustified
                    v-if="item.bailout_value"
                    :currencyValue="'IDR'"
                    :valueNumber="item.bailout_value"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <div slot="footer">
                  <div  v-if="totalBailout>0">
                    <div>
                        <span class="m-list-title">
                            Total Bailout :
                            {{
                            formatRupiah(totalBailout, "IDR" )
                            }}
                        </span>
                        <a-divider class="margin-small" />
                    </div>
                    <a-statistic title="Grand Total" :value="formatCurrency(data.mata_uang,data.keuangan.estimasi_harga)" class="m-text-align right" />
                  </div>
                  <a-row v-else type="flex">
                    <a-col :span="5" :order="1" class="m-text-align left"
                      >Grand Total</a-col
                    >
                    <a-col
                      :span="5"
                      :order="2"
                      class="m-text-align left m-text-bold"
                      >{{
                        formatCurrency(
                          data.mata_uang,
                          data.keuangan.estimasi_harga
                        )
                      }}</a-col
                    >
                  </a-row>
                </div>
              </a-table>
            </a-collapse-panel>
          </a-collapse>
          <a-card
            class="margin-top"
            :loading="loading"
            v-if="!getScreen & (data.jenis !== 'manifest')"
          >
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Action">
                <a-select
                  showSearch
                  v-decorator="['aksi', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleAction"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status
                    :status="
                      data.manifest.status == 'Revised' &&
                      data.manifest.cancel_sts == 1
                        ? 'Canceled'
                        : data.manifest.status
                    "
                  />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Creator - {{ data.manifest.user_pembuat }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.manifest.tanggal).format(
                          getDefaultDateFormat
                        )
                      }}
                    </h4>
                    <span class="m-text-small" v-if="data.manifest.remark">{{
                      data.manifest.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  color="green"
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4
                      class="margin-remove"
                      v-if="workflow.tanggal_aksi !== null"
                    >
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <!-- <a-collapse class="margin-top" activeKey="1"
            v-if="data.manifest.used_for=='1' || data.manifest.used_for=='2'">
            <a-collapse-panel key="1">
              <div
                      class="m-display-flex space-between align-middle"
                      slot="header"
              >
                <h4 class="margin-remove">Remark PP Priority GA / Purchasing </h4>
              </div>
              <Empty v-if="data.remark_pp_priority_ga_pur ===  null"/>
              <div v-else>
                <span class="m-timeline-title">{{data.remark_pp_priority_ga_pur.tlc ? data.remark_pp_priority_ga_pur.tlc:'-'}} /
                {{data.remark_pp_priority_ga_pur.dt? moment(data.remark_pp_priority_ga_pur.dt,getStandartFormatDate).format(getDefaultDateFormat):'-'}}
                </span>
                <br/>
                <span class="m-text-small" v-if="data.remark_pp_priority_ga_pur.remark"> {{data.remark_pp_priority_ga_pur.remark }}</span>
                <span class="m-text-small" v-else> Tidak ada catatan</span>
              </div>

            </a-collapse-panel>
          </a-collapse> -->

          <a-collapse
            class="margin-top"
            activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">PP Allocated Directorate 
                  ({{ data.remark_pp_keuangan?data.remark_pp_keuangan.direktorat:'-' }})</h4>
              </div>
              <Empty v-if="data.remark_pp_keuangan === null" />
              <div v-else>
                <span
                  v-if="data.remark_pp_keuangan.dt != '-'"
                  class="m-timeline-title"
                  >{{
                    data.remark_pp_keuangan.tlc
                      ? data.remark_pp_keuangan.tlc
                      : "-"
                  }}
                  /
                  {{
                    data.remark_pp_keuangan.dt
                      ? moment(
                          data.remark_pp_keuangan.dt,
                          getStandartFormatDate
                        ).format(getDefaultDateFormat)
                      : "-"
                  }}
                </span>
                <br v-if="data.remark_pp_keuangan.dt != '-'" />
                <span
                  class="m-text-small"
                  v-if="data.remark_pp_keuangan.remark"
                >
                  {{ data.remark_pp_keuangan.remark }}</span
                >
                <span class="m-text-small" v-else> Tidak ada catatan</span>
              </div>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse
            class="margin-top"
            activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Evidence Bailout</h4>
              </div>
              <Empty v-if="data.bailout && data.bailout.length==0" />
              <div v-else class="m-display-flex space-between align-middle">
                <div>
                  <span
                    v-if="data.bailout && data.bailout.transfer_dt != '-'"
                    class="m-timeline-title"
                    >{{
                      data.bailout.tlc_kas
                        ? data.bailout.tlc_kas
                        : "-"
                    }}
                    /
                    {{
                      data.bailout && data.bailout.transfer_dt
                        ? moment(
                            data.bailout.transfer_dt,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                  </span>
                  <br v-if="data.bailout && data.bailout.transfer_dt != '-'" />
                  <span
                    class="m-text-small"
                    v-if="data.bailout && data.bailout.note_transfer"
                  >
                    {{ data.bailout.note_transfer }}</span
                  >
                  <span class="m-text-small" v-else> Tidak ada catatan</span>
                </div>
                <a-button
                  v-if="data.bailout && data.bailout.file_transfer!=null"
                  class="margin-top"
                  style="margin-right: 10px"
                  @click="handleViewBailout(data.bailout.file_transfer)"
                  type="default"
                  icon="eye"
                  size="small"
                >View</a-button>
              </div>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">File Attachment</h4>
                <div>
                  <a-button
                    @click="addLampiran"
                    type="default"
                    size="small"
                    class="margin-right-small"
                    :disabled="data.lampiran[0].button_upload == 'disabled'"
                  >
                    upload
                    <a-icon type="upload" />
                  </a-button>
                </div>
              </div>
              <a-list
                itemLayout="horizontal"
                :dataSource="data.lampiran[0].list"
              >
                <Empty
                  v-if="
                    data.lampiran[0].list
                      ? data.lampiran[0].list.length <= 0
                      : data.lampiran[0].list
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div slot="title">
                      <a
                        @click="handleDownload(item)"
                        class="margin-remove m-text-dots"
                      >
                        {{ item.jenis ? item.jenis : "-" }}
                      </a>
                    </div>
                    <div slot="description">
                      <div class="m-display-flex space-between nowrap">
                        <h4 class="margin-remove m-text-dots">
                          {{ item.fungsi }}
                        </h4>
                        <a-button
                          v-if="data.manifest.user_creator === getAuth.username"
                          @click="handleRemoveExisting(item.id)"
                          size="small"
                          type="danger"
                          icon="delete"
                        ></a-button>
                      </div>
                      {{ item.tanggal }} | {{ item.tlc }}
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a @click="handleView(item)"
                        >{{ item.header }} | {{ item.tlc }}</a
                      >
                      <Status v-if="item.status"
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_manifest"
                    >
                      <span>{{ item.no_manifest }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl_mulai_dinas">
                      <span
                        >{{
                          moment(
                            item.tgl_mulai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}
                        -
                        {{
                          moment(
                            item.tgl_selesai_dinas,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        }}</span
                      >
                    </div>
                    <div slot="description" v-if="item.rest_api == 'po' || item.rest_api == 'wo'">
                      <div>
                        <strong>Supplier : </strong> {{item.nama_supplier}}
                      </div>
                    </div>
                    <div slot="description">
                      <div class="m-width-full">
                        <a-tooltip
                          class="ant-tooltip-inner"
                          placement="top"
                          :title="
                            item.deskripsi
                              ? item.deskripsi
                              : 'Tidak ada deskripsi'
                          "
                        >
                          <span class="ant-description-ellipses">{{
                            item.deskripsi
                              ? item.deskripsi
                              : "Tidak ada deskripsi"
                          }}</span>
                        </a-tooltip>
                      </div>
                    </div>
                    <div slot="title" v-if="item.value_transaksi">
                      <span class="m-timeline-title">{{
                        formatCurrency(data.mata_uang, item.value_transaksi)
                      }}</span>
                    </div>
                    <div slot="title" v-if="item.refund!=0">
                      <span class="m-timeline-title">Refund : {{
                        formatCurrency(data.mata_uang, item.refund)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>

          <a-card
            class="margin-top"
            :loading="loading"
            v-if="getScreen && data.jenis !== 'manifest'"
          >
            <div slot="title">Manifest Actions</div>

            <a-form :form="form">
              <a-form-item label="Note">
                <a-textarea
                  placeholder="Write the note here ... "
                  :rows="4"
                  v-decorator="['catatan']"
                />
              </a-form-item>
              <a-form-item label="Action">
                <a-select
                  showSearch
                  v-decorator="['aksi', { rules: [{ required: true }] }]"
                >
                  <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                    item.aksi
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleAction"
                  block
                  type="primary"
                  html-type="submit"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </a-card>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{
              moment(history.tgl_notif).format(getDateTimeFormat)
            }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{
              moment(history.tgl_notif).format(getDateTimeFormat)
            }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <a-modal
      v-model="visibleLampiran"
      @ok="addLampiran"
      :footer="null"
      @cancel="cancelLampiran"
    >
      <span slot="title">
        <a-icon type="reload" />&nbsp;Upload Attachment
      </span>

      <a-form :form="formLampiran">
        <a-form-item label="Document Type">
          <a-select v-decorator="['jenis', { rules: [{ required: true }] }]">
            <a-select-option value="Other">Other</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="Document Description">
          <a-input
            autocomplete="off"
            v-decorator="['fungsi', { rules: [{ required: true }] }]"
          ></a-input>
        </a-form-item>

        <a-form-item label="Upload Document File">
          <a-upload
            :remove="handleRemoveModal"
            v-decorator="[
              'file_list_lampiran',
              { rules: [{ required: true }] },
            ]"
            :file-list="fileListModalLampiran"
            :showUploadList="true"
            :beforeUpload="beforeUploadModal"
          >
            <a-button :disabled="fileListModalLampiran.length > 0" icon="upload"> Select File </a-button>
          </a-upload>
        </a-form-item>

        <a-form-item :wrapper-col="{ span: 24 }">
          <a-button
            @click="handleUploadLampiran"
            block
            type="danger"
            html-type="submit"
            >Save</a-button
          >
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import moment from "moment";

export default {
  name: "ManifestPP",
  components: { Status },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute],
  data() {
    return {
      loading: true,
      visibleHistory: false,
      data: {
        detail_pembelian: [],
        dokumen_terkait: [],
        keuangan: {},
        manifest: {},
        status: [],
        history: [],
        mata_uang: "",
        total_pemakaian: 0,
        remark_pp_priority_ga_pur: {},
        remark_pp_keuangan: {},
        lampiran: [
          {
            button_upload: "disabled",
            list: [],
          },
        ],
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
      printLoad: {
        manifest: false,
        cancel: false,
        close: false,
      },
      tableData: [],
      tableDataTemp: [],
      search: "",
      visibleLampiran: false,
      fileListLampiran: [],
      fileListModalLampiran: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formLampiran = this.$form.createForm(this);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
      }
    },
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeFormat",
      "getIsSpecialMenu",
      "getStandartFormatDate",
    ]),
    initialList() {
      let totalHarga = 0;
      let grandTotal = 0;
      let output = [];
      this.data.detail_pembelian.forEach((data) => {
        totalHarga = Number(data.harga) * Number(data.jumlah_barang);
        grandTotal = grandTotal + totalHarga;
        output = [...output, { data: data, totalHarga: totalHarga }];
      });

      return { output, grandTotal };
    },
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 60,
          align: "center",
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Item Name",
          //dataIndex: "item_name",
          width: 200,
          key: "item_name",
          scopedSlots: { customRender: "item_name" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Unit Price",
          dataIndex: "unit_price",
          key: "unit_price",
          width: 100,
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: "Amount",
          dataIndex: "amount",
          key: "amount",
          width: 100,
          scopedSlots: { customRender: "amount" },
        },
        {
          title: "Bailout Value",
          key: "bailout",
          width: 100,
          scopedSlots: { customRender: "bailout" },
        },
      ];
      return kolom;
    },

    searching() {
      if (this.search) {
        this.tableData = this.tableData.filter(
          (obj) =>
            obj.item_name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        this.tableData = this.tableDataTemp;
      }

      return this.tableData;
    },
    totalBailout(){
      let total = 0;
      this.data.detail_pembelian.forEach(item => {
          total = total + Number(item.bailout_value);
      });

      return total;
    }
  },
  methods: {
    moment,
    fetchManifest() {
      this.loading = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "pp",
        params: {
          user_pembuat: this.user_pembuat,
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            manifest: response.data.manifest[0],
            closed_status: response.data.closed_status,
            canceled_status: response.data.canceled_status,
            keuangan: response.data.keuangan_pp[0],
            detail_pembelian: response.data.detail_pembelian_pp,
            status: response.data.status_app,
            history: response.data.notifikasi,
            dokumen_terkait: response.data.dokumen_terkait,
            jenis: response.data.jenis,
            aksi: response.data.aksi,
            mata_uang: response.data.keuangan_pp[0].mata_uang.substring(0, 3),
            total_pemakaian: response.data.total_pemakaian,
            remark_pp_keuangan: response.data.remark_pp_keuangan[0],
            remark_pp_priority_ga_pur:
              response.data.remark_pp_priority_ga_pur[0],
            lampiran: response.data.file_attachment,
            ispibkkuploaded: response.data.ispibkkuploaded,
            bailout: response.data.bailout[0]
          };

          if (!this.getScreen) {
            let dataPemakaian = response.data.detail_pembelian_pp;
            response.data.detail_pembelian_pp.forEach((value, index) => {
              dataPemakaian[index]["no"] = index + 1;
              dataPemakaian[index]["key"] = index + 1;
              dataPemakaian[index]["item_name"] = value.nama_barang;
              dataPemakaian[index]["quantity"] =
                value.jumlah_barang + " " + value.satuan;
              dataPemakaian[index]["unit_price"] = {
                curr: value.currency,
                val: Number(value.harga),
              };
              dataPemakaian[index]["amount"] = {
                curr: value.currency,
                val: Number(value.harga * value.jumlah_barang),
              };
            });

            this.tableData = dataPemakaian;
            this.tableDataTemp = dataPemakaian;
          }

          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    handleAction() {
      this.confirmMessage("confirm-save");
    },
    handleActionProcess() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("choose-action");
          return;
        }

        Axios({
          method: "post",
          url: this.$serviceUrl + "pp/approval",
          processData: false,
          data: {
            id_pp: this.id,
            tlc: this.getAuth.username,
            status: values.aksi,
            remark: values.catatan ? values.catatan : "",
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handlePrintManifest() {
      this.printLoad.manifest = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "pp/cetak_laporan_pp",
        responseType: "blob",
        params: {
          id_pp: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" }),
            url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
          this.printLoad.manifest = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.printLoad.manifest = false;
          this.$router.go(-1);
        });
    },
    handlecanceltrans() {
      this.confirmMessageValue("confirm-cancel", null, null);
    },
    handleclosetrans() {
      this.confirmMessageValue("confirm-close", null, null);
    },
    canceltrans() {
      this.printLoad.cancel = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "pp",
        id_manifest: this.id,
        code_trans: this.data.manifest.no_pp,
        kode_project: this.data.manifest.proyek,
      };
      this.$store
        .dispatch("cancelTransaction", { auth: this.getAuth, data: data })
        .then((response) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    closetrans() {
      this.printLoad.close = true;
      const data = {
        tlc: this.getAuth.username,
        jenis_trans: "pp",
        id_pp: this.id,
        code_trans: this.data.manifest.no_pp,
        kode_project: this.data.manifest.proyek,
      };
      this.$store
        .dispatch("closeTransaction", {
          auth: this.getAuth,
          data: data,
          url: "pp/closed_pp",
        })
        .then((response) => {
          this.printLoad.close = false;
          this.displayMessageValue("successClose", response.data.message);
          this.$router.go();
        })
        .catch((error) => {
          this.printLoad.cancel = false;
          this.displayMessageValue("error", error.message);
        });
    },
    handleEdit() {
      this.$router.push({
        name: "editPp",
        params: { id: this.id, type: "revised" },
      });
    },
    addLampiran(e) {
      e.stopPropagation();
      this.visibleLampiran = !this.visibleLampiran;
    },
    cancelLampiran() {
      this.fileListModalLampiran = [];
      this.formLampiran.resetFields();
    },
    handleRemoveModal(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileListModal.indexOf(file);
        const newFileList = this.fileListModal.slice();
        newFileList.splice(index, 1);
        this.fileListModal = newFileList;
      } else {
        const index = this.fileListModalLampiran.indexOf(file);
        const newFileList = this.fileListModalLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListModalLampiran = newFileList;
      }
    },
    beforeUploadModal(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileListModal.push(file);
        } else {
          this.fileListModalLampiran.push(file);
        }
        return false;
      }
    },
    handleUploadLampiran() {
      this.formLampiran.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          this.formLampiran.return;
        }
        if (values.file_list_lampiran.fileList.length == 0) {
          this.displayMessage("form-warning");
          return;
        }

        let formData = new FormData();
        formData.append("id_manifest", this.id);
        formData.append("fungsi", values.fungsi);
        formData.append("jenis", values.jenis);
        formData.append("tlc", this.getAuth.username);
        formData.append("nama_document", values.file_list_lampiran.file);

        Axios({
          method: "post",
          url: this.$serviceUrl + "pp/upload_attachment",
          processData: false,
          data: formData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.displayMessage("success-upload");
            this.visibleLampiran = !this.visibleLampiran;
            console.log(this.$route);
            this.$router.go();
            console.log(this.$route);
            // this.$router.go()
            // const route = this.$router.resolve({
            //   name: this.$route.name,
            //   params: { id: this.id },
            // });
            // window.open(route.href, "_blank");
          })
          .catch((err) => {
            console.log("error : " + err);
          });
      });
    },
    handleDownload(item) {
      // if (item.source === "simfoni") {
      window.open(this.$serviceUrl + item.path, "_blank");
      // } else {
      //   window.open(item.link, "_blank");
      // }
    },
    handletomanifestAngg(anggaran_id, tahun_anggaran, path) {
      const route = this.$router.resolve({
        name: "anggaran.manifestAcc",
        params: {
          id: anggaran_id, rabview: false, budget_thn: tahun_anggaran, status:  'Approved'
        },
        query: { xc: path }
      });
      window.open(route.href, "_blank");
    },
    handleViewBailout(path){
      window.open(this.$serviceUrl + path);
    }
  },
  mounted() {
    this.fetchManifest();
    Event.$on("confirmMessageReturn", this.handleActionProcess);
    Event.$on("handleCancel", this.canceltrans);
    Event.$on("handleClose", this.closetrans);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleActionProcess);
    Event.$off("handleCancel", this.canceltrans);
    Event.$off("handleClose", this.closetrans);
  },
};
</script>

<style></style>
